// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/btnbg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.\\!container {
  width: 100% !important;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .\\!container {
    max-width: 640px !important;
  }

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .\\!container {
    max-width: 768px !important;
  }

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .\\!container {
    max-width: 1024px !important;
  }

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .\\!container {
    max-width: 1280px !important;
  }

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .\\!container {
    max-width: 1536px !important;
  }

  .container {
    max-width: 1536px;
  }
}
.visible {
  visibility: visible;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-2\\.5 {
  bottom: 0.625rem;
}
.bottom-3 {
  bottom: 0.75rem;
}
.bottom-5 {
  bottom: 1.25rem;
}
.left-0 {
  left: 0px;
}
.left-2 {
  left: 0.5rem;
}
.left-\\[-1000000px\\] {
  left: -1000000px;
}
.left-\\[-37px\\] {
  left: -37px;
}
.left-\\[10px\\] {
  left: 10px;
}
.left-\\[21\\%\\] {
  left: 21%;
}
.left-\\[50\\%\\] {
  left: 50%;
}
.left-\\[5px\\] {
  left: 5px;
}
.right-0 {
  right: 0px;
}
.right-1\\.5 {
  right: 0.375rem;
}
.right-3 {
  right: 0.75rem;
}
.right-\\[18px\\] {
  right: 18px;
}
.right-\\[21\\%\\] {
  right: 21%;
}
.right-\\[50px\\] {
  right: 50px;
}
.top-0 {
  top: 0px;
}
.top-1\\.5 {
  top: 0.375rem;
}
.top-\\[-1000000px\\] {
  top: -1000000px;
}
.top-\\[-5px\\] {
  top: -5px;
}
.top-\\[10px\\] {
  top: 10px;
}
.top-\\[13px\\] {
  top: 13px;
}
.top-\\[15px\\] {
  top: 15px;
}
.top-\\[18px\\] {
  top: 18px;
}
.top-\\[50\\%\\] {
  top: 50%;
}
.top-\\[5px\\] {
  top: 5px;
}
.z-10 {
  z-index: 10;
}
.z-30 {
  z-index: 30;
}
.z-\\[1\\] {
  z-index: 1;
}
.m-\\[1\\%\\] {
  margin: 1%;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-\\[2px\\] {
  margin-left: 2px;
  margin-right: 2px;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-2\\.5 {
  margin-top: 0.625rem;
  margin-bottom: 0.625rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-\\[10px\\] {
  margin-top: 10px;
  margin-bottom: 10px;
}
.my-\\[13px\\] {
  margin-top: 13px;
  margin-bottom: 13px;
}
.my-\\[15px\\] {
  margin-top: 15px;
  margin-bottom: 15px;
}
.my-\\[30px\\] {
  margin-top: 30px;
  margin-bottom: 30px;
}
.my-\\[5px\\] {
  margin-top: 5px;
  margin-bottom: 5px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-2\\.5 {
  margin-bottom: 0.625rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-\\[15px\\] {
  margin-bottom: 15px;
}
.mb-\\[20px\\] {
  margin-bottom: 20px;
}
.mb-\\[22px\\] {
  margin-bottom: 22px;
}
.mb-\\[25px\\] {
  margin-bottom: 25px;
}
.mb-\\[40px\\] {
  margin-bottom: 40px;
}
.mb-\\[5px\\] {
  margin-bottom: 5px;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-2\\.5 {
  margin-left: 0.625rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-\\[-1\\%\\] {
  margin-left: -1%;
}
.ml-\\[-10px\\] {
  margin-left: -10px;
}
.ml-\\[-19px\\] {
  margin-left: -19px;
}
.ml-\\[20px\\] {
  margin-left: 20px;
}
.ml-\\[25px\\] {
  margin-left: 25px;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-6 {
  margin-right: 1.5rem;
}
.mr-\\[12px\\] {
  margin-right: 12px;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-\\[100px\\] {
  margin-top: 100px;
}
.mt-\\[10px\\] {
  margin-top: 10px;
}
.mt-\\[13px\\] {
  margin-top: 13px;
}
.mt-\\[20px\\] {
  margin-top: 20px;
}
.mt-\\[25px\\] {
  margin-top: 25px;
}
.mt-\\[30px\\] {
  margin-top: 30px;
}
.mt-\\[3px\\] {
  margin-top: 3px;
}
.mt-\\[60px\\] {
  margin-top: 60px;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-\\[16\\/9\\] {
  aspect-ratio: 16/9;
}
.aspect-\\[4\\/5\\] {
  aspect-ratio: 4/5;
}
.\\!h-\\[35px\\] {
  height: 35px !important;
}
.h-0 {
  height: 0px;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-7 {
  height: 1.75rem;
}
.h-\\[100px\\] {
  height: 100px;
}
.h-\\[110px\\] {
  height: 110px;
}
.h-\\[130px\\] {
  height: 130px;
}
.h-\\[150px\\] {
  height: 150px;
}
.h-\\[15px\\] {
  height: 15px;
}
.h-\\[16px\\] {
  height: 16px;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[220px\\] {
  height: 220px;
}
.h-\\[24px\\] {
  height: 24px;
}
.h-\\[25px\\] {
  height: 25px;
}
.h-\\[265px\\] {
  height: 265px;
}
.h-\\[26px\\] {
  height: 26px;
}
.h-\\[28px\\] {
  height: 28px;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[320px\\] {
  height: 320px;
}
.h-\\[32px\\] {
  height: 32px;
}
.h-\\[350px\\] {
  height: 350px;
}
.h-\\[35px\\] {
  height: 35px;
}
.h-\\[38px\\] {
  height: 38px;
}
.h-\\[3px\\] {
  height: 3px;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[42px\\] {
  height: 42px;
}
.h-\\[45px\\] {
  height: 45px;
}
.h-\\[47px\\] {
  height: 47px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[55px\\] {
  height: 55px;
}
.h-\\[55vh\\] {
  height: 55vh;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-\\[70px\\] {
  height: 70px;
}
.h-\\[75px\\] {
  height: 75px;
}
.h-\\[80px\\] {
  height: 80px;
}
.h-fit {
  height: fit-content;
}
.h-full {
  height: 100%;
}
.min-h-\\[40vh\\] {
  min-height: 40vh;
}
.min-h-full {
  min-height: 100%;
}
.\\!w-\\[150px\\] {
  width: 150px !important;
}
.\\!w-\\[40\\%\\] {
  width: 40% !important;
}
.\\!w-\\[85\\%\\] {
  width: 85% !important;
}
.\\!w-full {
  width: 100% !important;
}
.w-10 {
  width: 2.5rem;
}
.w-3 {
  width: 0.75rem;
}
.w-4 {
  width: 1rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-7 {
  width: 1.75rem;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[110\\%\\] {
  width: 110%;
}
.w-\\[110px\\] {
  width: 110px;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-\\[130\\%\\] {
  width: 130%;
}
.w-\\[130px\\] {
  width: 130px;
}
.w-\\[135px\\] {
  width: 135px;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[16px\\] {
  width: 16px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[1px\\] {
  width: 1px;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[22px\\] {
  width: 22px;
}
.w-\\[25\\%\\] {
  width: 25%;
}
.w-\\[255px\\] {
  width: 255px;
}
.w-\\[25px\\] {
  width: 25px;
}
.w-\\[26px\\] {
  width: 26px;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-\\[31\\%\\] {
  width: 31%;
}
.w-\\[350px\\] {
  width: 350px;
}
.w-\\[360px\\] {
  width: 360px;
}
.w-\\[40px\\] {
  width: 40px;
}
.w-\\[42px\\] {
  width: 42px;
}
.w-\\[48px\\] {
  width: 48px;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-\\[520px\\] {
  width: 520px;
}
.w-\\[60px\\] {
  width: 60px;
}
.w-\\[75px\\] {
  width: 75px;
}
.w-\\[80\\%\\] {
  width: 80%;
}
.w-\\[80px\\] {
  width: 80px;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[280px\\] {
  min-width: 280px;
}
.min-w-\\[360px\\] {
  min-width: 360px;
}
.min-w-\\[520px\\] {
  min-width: 520px;
}
.min-w-\\[700px\\] {
  min-width: 700px;
}
.max-w-\\[85\\%\\] {
  max-width: 85%;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-\\[1\\.5\\] {
  flex: 1.5;
}
.flex-none {
  flex: none;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-pointer {
  cursor: pointer;
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-rows-none {
  grid-template-rows: none;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.self-end {
  align-self: flex-end;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-break-spaces {
  white-space: break-spaces;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[10px\\] {
  border-radius: 10px;
}
.rounded-\\[12px\\] {
  border-radius: 12px;
}
.rounded-\\[14px\\] {
  border-radius: 14px;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-\\[23px\\] {
  border-radius: 23px;
}
.rounded-\\[30px\\] {
  border-radius: 30px;
}
.rounded-\\[5px\\] {
  border-radius: 5px;
}
.rounded-\\[6px\\] {
  border-radius: 6px;
}
.rounded-\\[9px\\] {
  border-radius: 9px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-l-3xl {
  border-top-left-radius: 1.5rem;
  border-bottom-left-radius: 1.5rem;
}
.rounded-tr-\\[20px\\] {
  border-top-right-radius: 20px;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-solid {
  border-style: solid;
}
.border-none {
  border-style: none;
}
.\\!border-transparent {
  border-color: transparent !important;
}
.border-\\[\\#00A32E1A\\] {
  border-color: #00A32E1A;
}
.border-\\[\\#00A32E80\\] {
  border-color: #00A32E80;
}
.border-\\[\\#00A32E\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 163 46 / var(--tw-border-opacity, 1));
}
.border-\\[\\#26F028\\] {
  --tw-border-opacity: 1;
  border-color: rgb(38 240 40 / var(--tw-border-opacity, 1));
}
.border-\\[\\#DBDADA\\] {
  --tw-border-opacity: 1;
  border-color: rgb(219 218 218 / var(--tw-border-opacity, 1));
}
.border-primary {
  --tw-border-opacity: 1;
  border-color: rgb(0 163 46 / var(--tw-border-opacity, 1));
}
.border-second {
  --tw-border-opacity: 1;
  border-color: rgb(226 240 217 / var(--tw-border-opacity, 1));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.\\!bg-\\[\\#00000082\\] {
  background-color: #00000082 !important;
}
.\\!bg-\\[\\#000000\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#000000bd\\] {
  background-color: #000000bd !important;
}
.\\!bg-primary {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 163 46 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-second {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(226 240 217 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.bg-\\[\\#00000099\\] {
  background-color: #00000099;
}
.bg-\\[\\#003B00\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 59 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#008228\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 130 40 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#00A32E26\\] {
  background-color: #00A32E26;
}
.bg-\\[\\#00A32E61\\] {
  background-color: #00A32E61;
}
.bg-\\[\\#00A32E\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 163 46 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#00a0a326\\] {
  background-color: #00a0a326;
}
.bg-\\[\\#013B02\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(1 59 2 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#02290C\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(2 41 12 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#071207\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(7 18 7 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#082C11\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(8 44 17 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#09170C\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(9 23 12 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D9D9D985\\] {
  background-color: #D9D9D985;
}
.bg-\\[\\#D9D9D9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#DFECDD\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(223 236 221 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EAF4EA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(234 244 234 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5F8F6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 248 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FAFAFA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFFFFF36\\] {
  background-color: #FFFFFF36;
}
.bg-\\[\\#FFFFFF87\\] {
  background-color: #FFFFFF87;
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-grey-1 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 248 245 / var(--tw-bg-opacity, 1));
}
.bg-grey-2 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 244 / var(--tw-bg-opacity, 1));
}
.bg-grey-4 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 248 246 / var(--tw-bg-opacity, 1));
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(0 163 46 / var(--tw-bg-opacity, 1));
}
.bg-red-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 165 165 / var(--tw-bg-opacity, 1));
}
.bg-second {
  --tw-bg-opacity: 1;
  background-color: rgb(226 240 217 / var(--tw-bg-opacity, 1));
}
.bg-third {
  --tw-bg-opacity: 1;
  background-color: rgb(238 244 240 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.fill-\\[\\#00A32E80\\] {
  fill: #00A32E80;
}
.fill-\\[\\#24402C\\] {
  fill: #24402C;
}
.fill-\\[\\#E83D3D\\] {
  fill: #E83D3D;
}
.fill-white {
  fill: #ffffff;
}
.\\!p-0 {
  padding: 0px !important;
}
.\\!p-\\[18px\\] {
  padding: 18px !important;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-\\[10px\\] {
  padding: 10px;
}
.p-\\[15px\\] {
  padding: 15px;
}
.p-\\[30px\\] {
  padding: 30px;
}
.p-\\[35px\\] {
  padding: 35px;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[0px\\] {
  padding-left: 0px;
  padding-right: 0px;
}
.px-\\[10px\\] {
  padding-left: 10px;
  padding-right: 10px;
}
.px-\\[12px\\] {
  padding-left: 12px;
  padding-right: 12px;
}
.px-\\[14px\\] {
  padding-left: 14px;
  padding-right: 14px;
}
.px-\\[15px\\] {
  padding-left: 15px;
  padding-right: 15px;
}
.px-\\[16px\\] {
  padding-left: 16px;
  padding-right: 16px;
}
.px-\\[20px\\] {
  padding-left: 20px;
  padding-right: 20px;
}
.px-\\[22px\\] {
  padding-left: 22px;
  padding-right: 22px;
}
.px-\\[230px\\] {
  padding-left: 230px;
  padding-right: 230px;
}
.px-\\[25px\\] {
  padding-left: 25px;
  padding-right: 25px;
}
.px-\\[28px\\] {
  padding-left: 28px;
  padding-right: 28px;
}
.px-\\[30px\\] {
  padding-left: 30px;
  padding-right: 30px;
}
.px-\\[35px\\] {
  padding-left: 35px;
  padding-right: 35px;
}
.px-\\[50px\\] {
  padding-left: 50px;
  padding-right: 50px;
}
.px-\\[5px\\] {
  padding-left: 5px;
  padding-right: 5px;
}
.px-\\[6px\\] {
  padding-left: 6px;
  padding-right: 6px;
}
.px-\\[70px\\] {
  padding-left: 70px;
  padding-right: 70px;
}
.px-\\[8px\\] {
  padding-left: 8px;
  padding-right: 8px;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[15px\\] {
  padding-top: 15px;
  padding-bottom: 15px;
}
.py-\\[20px\\] {
  padding-top: 20px;
  padding-bottom: 20px;
}
.py-\\[25px\\] {
  padding-top: 25px;
  padding-bottom: 25px;
}
.py-\\[2px\\] {
  padding-top: 2px;
  padding-bottom: 2px;
}
.py-\\[30px\\] {
  padding-top: 30px;
  padding-bottom: 30px;
}
.py-\\[3px\\] {
  padding-top: 3px;
  padding-bottom: 3px;
}
.py-\\[4px\\] {
  padding-top: 4px;
  padding-bottom: 4px;
}
.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}
.py-\\[6px\\] {
  padding-top: 6px;
  padding-bottom: 6px;
}
.py-\\[7px\\] {
  padding-top: 7px;
  padding-bottom: 7px;
}
.py-\\[8px\\] {
  padding-top: 8px;
  padding-bottom: 8px;
}
.\\!pb-5 {
  padding-bottom: 1.25rem !important;
}
.\\!pt-2 {
  padding-top: 0.5rem !important;
}
.\\!pt-4 {
  padding-top: 1rem !important;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-\\[10px\\] {
  padding-bottom: 10px;
}
.pl-\\[255px\\] {
  padding-left: 255px;
}
.pl-\\[30px\\] {
  padding-left: 30px;
}
.pl-\\[75px\\] {
  padding-left: 75px;
}
.pr-\\[30px\\] {
  padding-right: 30px;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-8 {
  padding-top: 2rem;
}
.pt-\\[25px\\] {
  padding-top: 25px;
}
.pt-\\[60px\\] {
  padding-top: 60px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.\\!text-\\[13px\\] {
  font-size: 13px !important;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[22px\\] {
  font-size: 22px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.text-\\[40px\\] {
  font-size: 40px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\!font-semibold {
  font-weight: 600 !important;
}
.font-\\[500\\] {
  font-weight: 500;
}
.font-\\[700\\] {
  font-weight: 700;
}
.font-bold {
  font-weight: 700;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.capitalize {
  text-transform: capitalize;
}
.leading-\\[20px\\] {
  line-height: 20px;
}
.leading-\\[25px\\] {
  line-height: 25px;
}
.leading-\\[26px\\] {
  line-height: 26px;
}
.leading-\\[45px\\] {
  line-height: 45px;
}
.leading-none {
  line-height: 1;
}
.\\!text-primary {
  --tw-text-opacity: 1 !important;
  color: rgb(0 163 46 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#00A32E\\] {
  --tw-text-opacity: 1;
  color: rgb(0 163 46 / var(--tw-text-opacity, 1));
}
.text-\\[\\#00FF48CC\\] {
  color: #00FF48CC;
}
.text-\\[\\#26F028\\] {
  --tw-text-opacity: 1;
  color: rgb(38 240 40 / var(--tw-text-opacity, 1));
}
.text-\\[\\#34783C99\\] {
  color: #34783C99;
}
.text-\\[\\#3ADF53\\] {
  --tw-text-opacity: 1;
  color: rgb(58 223 83 / var(--tw-text-opacity, 1));
}
.text-\\[\\#848484\\] {
  --tw-text-opacity: 1;
  color: rgb(132 132 132 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B9C5B5\\] {
  --tw-text-opacity: 1;
  color: rgb(185 197 181 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FFFFFF80\\] {
  color: #FFFFFF80;
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-green-1 {
  --tw-text-opacity: 1;
  color: rgb(52 120 60 / var(--tw-text-opacity, 1));
}
.text-grey-3 {
  --tw-text-opacity: 1;
  color: rgb(144 149 155 / var(--tw-text-opacity, 1));
}
.text-primary {
  --tw-text-opacity: 1;
  color: rgb(0 163 46 / var(--tw-text-opacity, 1));
}
.text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.text-transparent {
  color: transparent;
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-80 {
  opacity: 0.8;
}
.\\!shadow-none {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-basic {
  --tw-shadow: 0px 4px 4px 0px #00000040;
  --tw-shadow-colored: 0px 4px 4px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-filter-box {
  --tw-shadow: 0px 4px 4px 0px #34783C40;
  --tw-shadow-colored: 0px 4px 4px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.\\!outline-none {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.\\!filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.cf-effect {
    transition: all linear 0.2s;
  }

html, body, #root, .app-container {
    height: 100%;
}

svg circle, svg rect, svg path{
    transition: all linear 0.2s;
}

.border-btn {
  display: flex;
  align-items: center;
  border-radius: 1.5rem;
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(0 163 46 / var(--tw-border-opacity, 1));
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  --tw-text-opacity: 1;
  color: rgb(0 163 46 / var(--tw-text-opacity, 1));
    transition: all linear 0.2s;
}

.border-btn:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(226 240 217 / var(--tw-bg-opacity, 1));
}

.cur-dragable {
  border-radius: 0.25rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(0 163 46 / var(--tw-border-opacity, 1));
  opacity: 0.6;
}

.bg-btn {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 150px;
  height: 35px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;

  cursor: pointer;
}

/* progress header bar */
.progress-bar {
  position: relative;

  background-color: #00A32E;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 0px;
    height: 0px;
    border-top: 25px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 25px solid transparent;
    border-left: 15px solid #013B02;

    filter: drop-shadow(6px 2px 4px #00000040);
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: -29px;
    width: 0px;
    height: 0px;
    border-top: 25px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 25px solid transparent;
    border-left: 15px solid #00A32E;
    z-index: 1;
    
    filter: drop-shadow(6px 2px 4px #00000040);
  }
}

/* border box */
.border-box {
  position: relative;
}

.border-box .top-left {
  position: absolute;
  top: 0;
  left: 0;
}

/* normal  */
.border-box .top-left::before {
  content: '';
  display: block;
  height: 4px;
  width: 140px;
  background: linear-gradient(90deg, #26F028 -2.08%, #011F21 100%);
}

.border-box .top-left::after {
  content: '';
  display: block;
  height: 80px;
  width: 4px;
  background-color: #26F028;
}

.border-box .top-right {
  position: absolute;
  top: 0;
  right: 0;
}

/* mormal */
.border-box .top-right::before {
  content: '';
  display: block;
  height: 4px;
  width: 140px;
  background: linear-gradient(270deg, #26F028 -2.08%, #011F21 100%);
}

.border-box .top-right::after {
  content: '';
  display: block;
  height: 80px;
  width: 4px;
  background-color: #26F028;
  position: absolute;
  right: 0;
  top: 0;
}

.border-box .bottom-right {
  position: absolute;
  bottom: 0;
  right: 0;
}

/* normal */
.border-box .bottom-right::before {
  content: '';
  display: block;
  height: 4px;
  width: 140px;
  background: linear-gradient(270deg, #26F028 -2.08%, #011F21 100%);
}

.border-box .bottom-right::after {
  content: '';
  display: block;
  height: 80px;
  width: 4px;
  background-color: #26F028;
  position: absolute;
  right: 0;
  bottom: 0;
}


.border-box .bottom-left {
  position: absolute;
  bottom: 0;
  left: 0;
}

.border-box .bottom-left::before {
  content: '';
  display: block;
  height: 4px;
  width: 140px;
  background: linear-gradient(90deg, #26F028 -2.08%, #011F21 100%);
}

.border-box .bottom-left::after {
  content: '';
  display: block;
  height: 80px;
  width: 4px;
  background-color: #26F028;
  position: absolute;
  left: 0;
  bottom: 0;
}

/* small */ 
.border-box .small::before {
  content: '';
  height: 2px;
  width: 70px;
}

.border-box .small::after {
  content: '';
  height: 40px;
  width: 2px;
}

/* small */ 
.border-box .x-small::before {
  content: '';
  height: 1.5px;
  width: 40px;
}

.border-box .x-small::after {
  content: '';
  height: 10px;
  width: 1.5px;
}


/* modal */
.planogram-check-upload {
  background-color: red;
}

/* ant design */
.planogram_check_spin_full .ant-spin-fullscreen {
  width: 100% !important;
  height: 100% !important;
}

.planogram-popup-win .ant-spin-fullscreen {
  width: 100% !important;
  height: 100% !important;
}

.after\\:content-none::after {
  --tw-content: none;
  content: var(--tw-content);
}

.hover\\:bg-\\[\\#00A32E\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 163 46 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-second:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(226 240 217 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-third:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 244 240 / var(--tw-bg-opacity, 1));
}

.hover\\:font-bold:hover {
  font-weight: 700;
}

.hover\\:text-\\[\\#013B02\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(1 59 2 / var(--tw-text-opacity, 1));
}

.hover\\:text-green-1:hover {
  --tw-text-opacity: 1;
  color: rgb(52 120 60 / var(--tw-text-opacity, 1));
}

.hover\\:text-primary:hover {
  --tw-text-opacity: 1;
  color: rgb(0 163 46 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:block {
  display: block;
}

.group:hover .group-hover\\:flex {
  display: flex;
}

.group:hover .group-hover\\:text-\\[\\#00A32E\\] {
  --tw-text-opacity: 1;
  color: rgb(0 163 46 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

@media (min-width: 640px) {

  .sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}

@media (min-width: 768px) {

  .md\\:block {
    display: block;
  }

  .md\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 1280px) {

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (min-width: 1536px) {

  .\\32xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .\\32xl\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}

.\\[\\&\\>div\\.ant-tabs-nav\\]\\:mb-0>div.ant-tabs-nav {
  margin-bottom: 0px;
}

.\\[\\&\\>div\\.ant-tabs-nav\\]\\:before\\:border-\\[1\\.5px\\]>div.ant-tabs-nav::before {
  content: var(--tw-content);
  border-width: 1.5px;
}

.\\[\\&\\>div\\.ant-tabs-nav\\]\\:before\\:border-none>div.ant-tabs-nav::before {
  content: var(--tw-content);
  border-style: none;
}

.\\[\\&\\>div\\.ant-tabs-nav\\]\\:before\\:border-\\[\\#00A32E1A\\]>div.ant-tabs-nav::before {
  content: var(--tw-content);
  border-color: #00A32E1A;
}

.\\[\\&\\>div\\.card-content\\]\\:\\!p-0>div.card-content {
  padding: 0px !important;
}

.\\[\\&\\>div\\>div\\.resonse-label\\]\\:w-1\\/3>div>div.resonse-label {
  width: 33.333333%;
}

.\\[\\&_\\.ant-select-selection-item\\]\\:\\!ml-\\[25px\\] .ant-select-selection-item {
  margin-left: 25px !important;
}

.\\[\\&_\\.ant-select-selection-search-input\\]\\:\\!ml-\\[25px\\] .ant-select-selection-search-input {
  margin-left: 25px !important;
}

.\\[\\&_\\.ant-select-selector\\]\\:rounded-3xl .ant-select-selector {
  border-radius: 1.5rem;
}

.\\[\\&_\\.ant-select-selector\\]\\:\\!border-none .ant-select-selector {
  border-style: none !important;
}

.\\[\\&_\\.ant-select-selector\\]\\:\\!bg-transparent .ant-select-selector {
  background-color: transparent !important;
}

.\\[\\&_div\\.ant-select-selector\\]\\:\\!bg-third div.ant-select-selector {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(238 244 240 / var(--tw-bg-opacity, 1)) !important;
}`, "",{"version":3,"sources":["webpack://./src/modules/planogram-check/tailwind.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAWjB;IACE,2BAA2B;EAC7B;;AAXF;IACI,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AASI;EAAA,aAA2J;EAA3J,mBAA2J;EAA3J,qBAA2J;EAA3J,iBAA2J;EAA3J,sBAA2J;EAA3J,yDAA2J;EAA3J,kBAA2J;EAA3J,mBAA2J;EAA3J,gBAA2J;EAA3J,mBAA2J;EAA3J,eAA2J;EAA3J,gBAA2J;EAA3J,cAA2J;EAA3J,oBAA2J;EAA3J,gDAA2J;IAA3J;AAA2J;;AAA3J;EAAA,kBAA2J;EAA3J;AAA2J;;AAI3J;EAAA,sBAA+C;EAA/C,iBAA+C;EAA/C,sBAA+C;EAA/C,yDAA+C;EAA/C;AAA+C;;AAGnD;EACE,mDAA0C;EAC1C,YAAY;EACZ,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;;EAE1B,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;;EAElB,yBAAyB;;EAEzB;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,WAAW;IACX,kCAAkC;IAClC,oCAAoC;IACpC,qCAAqC;IACrC,+BAA+B;;IAE/B,0CAA0C;EAC5C;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,UAAU;IACV,WAAW;IACX,kCAAkC;IAClC,oCAAoC;IACpC,qCAAqC;IACrC,+BAA+B;IAC/B,UAAU;;IAEV,0CAA0C;EAC5C;AACF;;AAEA,eAAe;AACf;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gEAAgE;AAClE;;AAEA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA,WAAW;AACX;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iEAAiE;AACnE;;AAEA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA,WAAW;AACX;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iEAAiE;AACnE;;AAEA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gEAAgE;AAClE;;AAEA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,OAAO;EACP,SAAS;AACX;;AAEA,UAAU;AACV;EACE,WAAW;EACX,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,WAAW;EACX,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;;AAGA,UAAU;AACV;EACE,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AA9NA;EAAA,kBA8NC;EA9ND;AA8NC;;AA9ND;EAAA,kBA8NC;EA9ND;AA8NC;;AA9ND;EAAA,kBA8NC;EA9ND;AA8NC;;AA9ND;EAAA,kBA8NC;EA9ND;AA8NC;;AA9ND;EAAA;AA8NC;;AA9ND;EAAA,oBA8NC;EA9ND;AA8NC;;AA9ND;EAAA,oBA8NC;EA9ND;AA8NC;;AA9ND;EAAA,oBA8NC;EA9ND;AA8NC;;AA9ND;EAAA;AA8NC;;AA9ND;EAAA;AA8NC;;AA9ND;EAAA,oBA8NC;EA9ND;AA8NC;;AA9ND;EAAA;AA8NC;;AA9ND;;EAAA;IAAA;EA8NC;AAAA;;AA9ND;;EAAA;IAAA;EA8NC;;EA9ND;IAAA;EA8NC;;EA9ND;IAAA;EA8NC;AAAA;;AA9ND;;EAAA;IAAA;EA8NC;;EA9ND;IAAA;EA8NC;AAAA;;AA9ND;;EAAA;IAAA;EA8NC;;EA9ND;IAAA;EA8NC;AAAA;;AA9ND;;EAAA;IAAA;EA8NC;;EA9ND;IAAA;EA8NC;AAAA;;AA9ND;EAAA;AA8NC;;AA9ND;EAAA,0BA8NC;EA9ND;AA8NC;;AA9ND;EAAA,0BA8NC;EA9ND;AA8NC;;AA9ND;EAAA,0BA8NC;EA9ND;AA8NC;;AA9ND;EAAA;AA8NC;;AA9ND;EAAA;AA8NC;;AA9ND;EAAA;AA8NC;;AA9ND;EAAA;AA8NC;;AA9ND;EAAA;AA8NC;;AA9ND;EAAA;AA8NC;;AA9ND;EAAA;AA8NC;;AA9ND;EAAA,6BA8NC;EA9ND;AA8NC","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nhtml, body, #root, .app-container {\n    height: 100%;\n}\n\nsvg circle, svg rect, svg path{\n    transition: all linear 0.2s;\n}\n\n@layer utilities {\n  .cf-effect {\n    transition: all linear 0.2s;\n  }\n}\n\n.border-btn {\n    @apply cf-effect border-2 border-primary rounded-3xl px-[15px] py-[8px] flex items-center text-primary hover:bg-second text-[14px] font-normal leading-none;\n}\n\n.cur-dragable {\n    @apply border border-primary rounded opacity-60;\n}\n\n.bg-btn {\n  background: url(./assets/images/btnbg.png);\n  width: 150px;\n  height: 35px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n\n  cursor: pointer;\n}\n\n/* progress header bar */\n.progress-bar {\n  position: relative;\n\n  background-color: #00A32E;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 0px;\n    height: 0px;\n    border-top: 25px solid transparent;\n    border-right: 15px solid transparent;\n    border-bottom: 25px solid transparent;\n    border-left: 15px solid #013B02;\n\n    filter: drop-shadow(6px 2px 4px #00000040);\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: -29px;\n    width: 0px;\n    height: 0px;\n    border-top: 25px solid transparent;\n    border-right: 15px solid transparent;\n    border-bottom: 25px solid transparent;\n    border-left: 15px solid #00A32E;\n    z-index: 1;\n    \n    filter: drop-shadow(6px 2px 4px #00000040);\n  }\n}\n\n/* border box */\n.border-box {\n  position: relative;\n}\n\n.border-box .top-left {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n/* normal  */\n.border-box .top-left::before {\n  content: '';\n  display: block;\n  height: 4px;\n  width: 140px;\n  background: linear-gradient(90deg, #26F028 -2.08%, #011F21 100%);\n}\n\n.border-box .top-left::after {\n  content: '';\n  display: block;\n  height: 80px;\n  width: 4px;\n  background-color: #26F028;\n}\n\n.border-box .top-right {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n/* mormal */\n.border-box .top-right::before {\n  content: '';\n  display: block;\n  height: 4px;\n  width: 140px;\n  background: linear-gradient(270deg, #26F028 -2.08%, #011F21 100%);\n}\n\n.border-box .top-right::after {\n  content: '';\n  display: block;\n  height: 80px;\n  width: 4px;\n  background-color: #26F028;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.border-box .bottom-right {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n\n/* normal */\n.border-box .bottom-right::before {\n  content: '';\n  display: block;\n  height: 4px;\n  width: 140px;\n  background: linear-gradient(270deg, #26F028 -2.08%, #011F21 100%);\n}\n\n.border-box .bottom-right::after {\n  content: '';\n  display: block;\n  height: 80px;\n  width: 4px;\n  background-color: #26F028;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n}\n\n\n.border-box .bottom-left {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n}\n\n.border-box .bottom-left::before {\n  content: '';\n  display: block;\n  height: 4px;\n  width: 140px;\n  background: linear-gradient(90deg, #26F028 -2.08%, #011F21 100%);\n}\n\n.border-box .bottom-left::after {\n  content: '';\n  display: block;\n  height: 80px;\n  width: 4px;\n  background-color: #26F028;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n}\n\n/* small */ \n.border-box .small::before {\n  content: '';\n  height: 2px;\n  width: 70px;\n}\n\n.border-box .small::after {\n  content: '';\n  height: 40px;\n  width: 2px;\n}\n\n/* small */ \n.border-box .x-small::before {\n  content: '';\n  height: 1.5px;\n  width: 40px;\n}\n\n.border-box .x-small::after {\n  content: '';\n  height: 10px;\n  width: 1.5px;\n}\n\n\n/* modal */\n.planogram-check-upload {\n  background-color: red;\n}\n\n/* ant design */\n.planogram_check_spin_full .ant-spin-fullscreen {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.planogram-popup-win .ant-spin-fullscreen {\n  width: 100% !important;\n  height: 100% !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
